import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsListUl} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";
import {WithdrawalSourcesModal} from "./sources_modal";
import FileCell from "../system/fileViewer";


const TABLE_HEAD = ["#", "کاربر", "مبلغ", "شبا", "توضیحات", "وضعیت", "رسید", "زمان", "عملیات"];

export function AdminWithdrawalGrid({
                                      withdrawals,
                                      setModalOpen,
                                      setSelectedRow,
                                    }) {

  const [selectedHead, setSelectedHead] = useState("#")
  const [sourcesModalOpen, setSourcesModalOpen] = useState(false);
  const [selectedWithdrawalSources, setSelectedWithdrawalSources] = useState(null);

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مبلغ": "value",
    "شبا": "bank_sheba",
    "توضیحات": "description",
    "وضعیت": "status",
    "رسید": "receipt",
    "زمان": "created_at",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مبلغ": true,
    "شبا": true,
    "توضیحات": true,
    "وضعیت": true,
    "رسید": false,
    "زمان": true,
    "عملیات": false,
  }

  return (
    <div className="w-full overflow-x-auto rounded-xl border border-blue-gray-100 [&_button]:min-w-0 [&_button]:px-1 [&_button]:py-2">
      {sourcesModalOpen && (
        <WithdrawalSourcesModal
          withdrawal={selectedWithdrawalSources}
          open={sourcesModalOpen}
          setOpen={setSourcesModalOpen}
        />
      )}
      <table className="w-full min-w-[1100px] table-fixed text-left">
        <colgroup>
          <col className="w-[4%]"/>
          <col className="w-[13%]"/>
          <col className="w-[10%]"/>
          <col className="w-[15%]"/>
          <col className="w-[15%]"/>
          <col className="w-[10%]"/>
          <col className="w-[8%]"/>
          <col className="w-[12%]"/>
          <col className="w-[8%]"/>
        </colgroup>
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter divide-y divide-blue-gray-50">
        {withdrawals.length === 0 && (
          <tr>
            <td colSpan={TABLE_HEAD.length} className="py-12 text-center">
              <Typography color="blue-gray" className="font-normal">
                موردی یافت نشد
              </Typography>
            </td>
          </tr>
        )}
        {withdrawals.map(
          ({
             id,
             person_name,
             phone,
             value,
             bank_sheba,
             description,
             status,
             receipt,
             created_at,
             sources
           }, index) => {
            const classes = "p-2";

            return (
              <tr key={id} className="transition-colors hover:bg-blue-gray-50">

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(value, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(bank_sheba)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      <Chip
                        variant="ghost"
                        value={status === "accepted" ? "انجام شده" : status === "new" ? "در انتظار بررسی" : status === "rejected" ? "رد شده" : status === "canceled" ? "لغو شده" : status}
                        color={status === "accepted" ? "green" : status === "new" ? "amber" : status === "rejected" ? "red" : "red"}
                      />
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    {receipt && <FileCell fileCode={receipt}/>}
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(created_at.split(" ")[0])}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(created_at.split(" ")[1])}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex items-center justify-center gap-1">
                    <Tooltip content="منابع">
                      <IconButton
                        variant="text"
                        className="text-align=right"
                        disabled={!sources || sources.length === 0}
                        onClick={() => {
                          setSelectedRow(withdrawals[index]);
                          setSelectedWithdrawalSources(withdrawals[index]);
                          setSourcesModalOpen(true);
                        }}
                      >
                        <BsListUl className="h-4 w-4"/>
                      </IconButton>
                    </Tooltip>
                    <Tooltip content="ویرایش">
                      <IconButton variant="text" className="text-align=right" onClick={() => {
                        setSelectedRow(withdrawals[index]);
                        setModalOpen(true);
                      }}>
                        <PencilIcon className="h-4 w-4"/>
                      </IconButton>
                    </Tooltip>
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}
